/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type VolunteerShiftsQueryVariables = Types.Exact<{
  where: Types.VolunteerShiftWhereInput;
}>;

export type VolunteerShiftsQuery = {
  volunteerShifts: Array<
    Pick<
      Types.VolunteerShift,
      | "shift_id"
      | "category_name"
      | "registration_open"
      | "organizer_responsible_user_id"
      | "preferred_min_signups"
      | "description"
    > & {
      organizer_responsible?: Types.Maybe<Pick<Types.User, "name">>;
      category: Pick<Types.VolunteerCategory, "name" | "primary_only">;
      shift: Pick<
        Types.EventActivity,
        | "category"
        | "created_at"
        | "end_time"
        | "event_id"
        | "id"
        | "location"
        | "name"
        | "restrictions"
        | "start_time"
        | "updated_at"
        | "slug"
        | "restrictions_string"
      > & {
        shift_signups?: Types.Maybe<
          Array<
            Pick<Types.ShiftSignup, "event_attendee_id" | "shift_id"> & {
              event_attendee: {
                user: Pick<Types.User, "id" | "name" | "email">;
              };
            }
          >
        >;
      };
    }
  >;
};

export const VolunteerShiftsDocument = gql`
  query VolunteerShifts($where: VolunteerShiftWhereInput!) {
    volunteerShifts(where: $where) {
      shift_id
      category_name
      registration_open
      organizer_responsible_user_id
      organizer_responsible {
        name
      }
      preferred_min_signups
      description
      category {
        name
        primary_only
      }
      shift {
        category
        created_at
        end_time
        event_id
        id
        location
        name
        restrictions
        start_time
        updated_at
        slug
        restrictions_string
        shift_signups {
          event_attendee_id
          shift_id
          event_attendee {
            user {
              id
              name
              email
            }
          }
        }
      }
    }
  }
`;

/**
 * __useVolunteerShiftsQuery__
 *
 * To run a query within a React component, call `useVolunteerShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVolunteerShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVolunteerShiftsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useVolunteerShiftsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    VolunteerShiftsQuery,
    VolunteerShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    VolunteerShiftsQuery,
    VolunteerShiftsQueryVariables
  >(VolunteerShiftsDocument, baseOptions);
}
export function useVolunteerShiftsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    VolunteerShiftsQuery,
    VolunteerShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    VolunteerShiftsQuery,
    VolunteerShiftsQueryVariables
  >(VolunteerShiftsDocument, baseOptions);
}
export type VolunteerShiftsQueryHookResult = ReturnType<
  typeof useVolunteerShiftsQuery
>;
export type VolunteerShiftsLazyQueryHookResult = ReturnType<
  typeof useVolunteerShiftsLazyQuery
>;
export type VolunteerShiftsQueryResult = ApolloReactCommon.QueryResult<
  VolunteerShiftsQuery,
  VolunteerShiftsQueryVariables
>;
